import axios from "axios";

const server = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true
})

export class DeliveryOrdersFetchAPI {

    //Function to register the delivery order
    static async registerDeliveryOrder(token, data){
        const res = await server(`/deliveryOrder`, {
            method: "post",
            headers: token ? { 'x-access-token': token } : undefined,
            data: data,
        });
        return res;
    }

    //Function to get delivery order by id
    static async getDeliveryOrderById(token, id){
        const res = await server(`/deliveryOrder/${id}`, {
            method: "get",
            headers: token ? { 'x-access-token': token } : undefined,
        });
        return res;
    }
}